<template>
	<div class="basic_wrap">
		<div class="red_top_bg">
			<div class="back_left" @click="$router.back()"></div>
		</div>
		<form class="form" @submit.prevent="submit">
			<div class="tittle_verified">
				{{$t('authReal.title')}}
			</div>
			<!-- <div class="" style="color:#ffffff">
				{{$t('authEmail.tip')}}
				{{data.mobile}}
			</div> -->
			<div v-if="data.is_apply==0">
				<div class="item">
				<input v-model.trim="realname" type="text" class="inp" :placeholder="$t('authReal.realname')" >
				<!-- <van-count-down
					:time="time"
					class="btn get_captcha"
					@finish="timeCall"
				>
					<template v-slot="timeData">
					<span @click="sendcode">{{
						timeData.seconds > 0
						? timeData.seconds
						: $t('authEmail.sendcode')
					}}</span>
					</template>
				</van-count-down> -->
				</div>
				<div class="item">
					<input v-model.trim="idcard" type="text" class="inp" :placeholder="$t('authReal.idcard_no')" >
				</div>
				<div class="qrcode">
					<div>{{$t('authReal.idcard_img1')}}</div>
					<div class="qrcode_img">
						<van-uploader v-model="fileList1" multiple :max-count="1" class="upload" :max-size="10 * 1024 * 1024" @oversize="onOversize" :after-read="afterRead1"
							:before-read="beforeRead">
						</van-uploader>
					</div>
				</div>
				<div class="qrcode">
					<div>{{$t('authReal.idcard_img2')}}</div>
					<div class="qrcode_img">
						<van-uploader v-model="fileList2" multiple :max-count="1" class="upload" :max-size="10 * 1024 * 1024" @oversize="onOversize" :after-read="afterRead2"
							:before-read="beforeRead">
						</van-uploader>
					</div>
				</div>
				<!-- <div class="qrcode">
					<div>{{$t('authReal.idcard_img3')}}</div>
					<div class="qrcode_img">
						<van-uploader v-model="fileList3" multiple :max-count="1" class="upload" :max-size="10 * 1024 * 1024" @oversize="onOversize" :after-read="afterRead3"
							:before-read="beforeRead">
						</van-uploader>
					</div>
				</div> -->
				<div style="color: #fff;">
					<van-checkbox v-model="checked" shape="square" icon-size="14px">{{$t('authReal.agree1')}}<span @click="$router.push('/about/13')">{{ $t('index.secret') }}</span>{{$t('authReal.agree2')}}</van-checkbox>
					
				</div>
				<button type="submit" class="basic_btn sbtn" :class="code==''?'no_touch':''">{{$t('authEmail.submit')}}</button>
			</div>
			<div v-else>
				<div class="qrcode">
					<div>{{$t('authReal.applyed')}}</div>
					
				</div>
			</div>
		</form>
	</div>
</template>

<script>
	import Vue from "vue";
	import { CountDown, Checkbox,Uploader,Toast} from "vant";
	import Fetch from '../../utils/fetch';
	import bsHeader from '../../components/bsHeader.vue';
	import Api from "../../interface/index";
    import axios from 'axios'
	Vue.use(CountDown).use(Uploader)
	    .use(Checkbox);
	export default {
		name: "setpwd",
		components: {
			bsHeader
		},
		data() {
			return {
				data: {},
				time: 0,
				code: '',
				fileList1: [],
				fileList2: [],
				fileList3: [],
				realname:'',
				idcard:'',
				realimg1:'',
				realimg2:'',
				realimg3:'',
				checked: true,
			};
		},
		created() {
			this.$parent.footer('user',false);
		},
		mounted() {
			this.start();	
		},
		methods: {
			onOversize(file) {
			    this.$toast(this.$t('account.within2megabytes'));
			},
			beforeRead(file) {
			    if (file.type !== 'image/jpeg' && file.type !== 'image/jpg' && file.type !== 'image/png') {
			        this.$toast(this.$t('account.supportPicture'));
			        return false;
			    }
			    return true;
			},
			afterRead1(file) {
			    let formData = new FormData();
				formData.append('language', this.$i18n.locale||"zh_cn");
			    formData.append('file', file.file);
			    formData.append('id', this.$router.history.current.params.id);
				formData.append('token', localStorage.getItem('token'));
				Toast.loading({
					forbidClick: true,
					duration: 20000
				});
				
			    axios.post(Api.commonUrl+"/api/index/bank_link_upload", formData).then((r) => {
					Toast.clear();
					if (r.data.code === 1) {
						this.realimg1 = r.data.data;
			        } else {
			            if (r.data.info) {
			                this.$toast(r.data.info);
			            } else {
			                this.$toast(this.$t('account.uploadFail'));
			            }
			        }
			    });
			},
			afterRead2(file) {
			    let formData = new FormData();
				formData.append('language', this.$i18n.locale||"zh_cn");
			    formData.append('file', file.file);
			    formData.append('id', this.$router.history.current.params.id);
				formData.append('token', localStorage.getItem('token'));
				Toast.loading({
					forbidClick: true,
					duration: 20000
				});
				
			    axios.post(Api.commonUrl+"/api/index/bank_link_upload", formData).then((r) => {
					Toast.clear();
					if (r.data.code === 1) {
						this.realimg2 = r.data.data;
			        } else {
			            if (r.data.info) {
			                this.$toast(r.data.info);
			            } else {
			                this.$toast(this.$t('account.uploadFail'));
			            }
			        }
			    });
			},
			afterRead3(file) {
			    let formData = new FormData();
				formData.append('language', this.$i18n.locale||"zh_cn");
			    formData.append('file', file.file);
			    formData.append('id', this.$router.history.current.params.id);
				formData.append('token', localStorage.getItem('token'));
				Toast.loading({
					forbidClick: true,
					duration: 20000
				});
				
			    axios.post(Api.commonUrl+"/api/index/bank_link_upload", formData).then((r) => {
					Toast.clear();
					if (r.data.code === 1) {
						this.realimg3 = r.data.data;
			        } else {
			            if (r.data.info) {
			                this.$toast(r.data.info);
			            } else {
			                this.$toast(this.$t('account.uploadFail'));
			            }
			        }
			    });
			},
			start() {
				Fetch('/user/info').then((r) => {
					this.data = r.data;
				});
			},
			timeCall() {
			    this.is_send = false;
			    this.time = 0;
			},
			sendcode() {
			    if (this.is_send) {
			        return;
			    }
			    this.is_send = true;
			
			    Fetch("/index/auth_email_code").then(() => {
			            this.time = 60 * 1000;
			            this.$toast({
			                background: "#07c160",
			                message: this.$t('authEmail.sendsuccess'),
			            });
			        })
			        .catch(() => {
			            this.is_send = false;
			        });
			},
			submit() {
				
				if (!this.checked) {
					this.$toast(this.$t('authReal.checktip'));
					return false;
				}
				if (!this.realname) {
					this.$toast(this.$t('authReal.realnametip'));
					return false;
				}
				if (!this.idcard) {
					this.$toast(this.$t('authReal.idcard_no'));
					return false;
				}
				if (!this.realimg1) {
					this.$toast(this.$t('authReal.idcard_img1_tip'));
					return false;
				}
				if (!this.realimg2) {
					this.$toast(this.$t('authReal.idcard_img2_tip'));
					return false;
				}
				// if (!this.realimg3) {
				// 	this.$toast(this.$t('authReal.idcard_img3_tip'));
				// 	return false;
				// }

				Fetch('/user/auth_email', {
					'realname':this.realname,
					'idcardno':this.idcard,
					'realimg1':this.realimg1,
					'realimg2':this.realimg2,
					'realimg3':this.realimg3
				}).then(() => {
					this.$toast({
						background: '#07c160',
						message: this.$t('authReal.success')
					});
					if(this.$route.query.redirect){
						this.$router.replace(this.$route.query.redirect+"&money="+this.$route.query.money)
					}else{ 
						this.$router.replace('/safe')
					}
				});
			},
		}
	};
</script>

<style lang="less" scoped>
	.back_left {
		background: url(../../views/images/item/back_b.png) no-repeat center center;
	}
	.big_tit{
		color: #000000;
	}
	.tittle_verified{
		margin-top: 40px;
		margin-bottom: 20px;
		font-size: 26px;
		color:#ffffff;
	}
	.form{
		width: 100%;
		margin-top: 32px;
		padding: 0 20px;
		.item{
			width: 100%;
			height: 45px;
			border-radius: 2px;
			border-bottom: 1px solid rgba(0, 0, 0, 0.1);
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin: 20px 0;
			background-color: #3d11a4;
			padding-right: 10px;
			input{
				flex: 1;
				padding: 0 10px;
				height: 22px;
				font-size: 16px;
				line-height: 22px;
				color:#ffffff;
			}
			.right_icon{
				width: 13px;
				height: 13px;
				background: url(../images/item/clear.png) no-repeat center center;
				background-size: 100% 100%;
				margin-right: 12px;
			}
			.get_captcha{
				color: #ffffff;
			}
		}
	}
	.basic_btn{
		width: 100%;
		margin-top:10px;
	}
	.qrcode{
		//padding-top: 30px;
		//padding-bottom: 30px;
		//text-align: center;
		div{
			color: #999;
			font-size: 14px;
			margin-bottom: 10px;
		}
		.upload{
			width: 100%;
			height: 100%;
		}
		.qrcode_img{
			width: 120px;
			height: 90px;
			//margin: 0 auto;
			
			span{
				line-height: 220px;
			}
			img{
				width: 120px;
				height: 90px;
				position: relative;
				top: -255px;
			}
		}
	}
	
/deep/ .van-checkbox__icon--checked .van-icon {
    color: #fff;
    background-color: #ff5a50;
    border-color: #ff5a50;
}
/deep/ .van-checkbox__label{
	color: #ff5a50;
}
</style>
